import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Input,
    AfterViewInit,
    OnDestroy
} from '@angular/core';
import { Observable } from 'rxjs';
import { IAttachment } from '../shared';
import { LoggingService } from '../shared/services/logging/logging.service';
import { AttachmentService } from './attachment.service';
import { DomSanitizer } from '@angular/platform-browser';
import { takeWhile, tap, map } from 'rxjs/operators';

@Component({
    selector: 'ef-attachment-view-feature',
    templateUrl: './attachment-view-feature.component.html',
    styleUrls: ['./attachment-view-feature.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AttachmentViewFeatureComponent
    implements OnInit, OnDestroy, AfterViewInit {
    @Input() public fileId: string;
    public attachment$: Observable<IAttachment>;
    public attachment: IAttachment;
    private active = true;
    constructor(
        private log: LoggingService,
        protected svc: AttachmentService,
        private sanitizer: DomSanitizer
    ) {
    }

    ngOnInit() {
        this.log.verbose({ type: 'AttachmentViewFeatureComponent' });
        this.setupObservables();
    }
    ngOnDestroy() {
        this.active = false;
    }
    setupObservables() {
        this.attachment$ = this.svc.getAttachment(this.fileId).pipe(
            tap(a =>
                this.log.verbose({
                    type: 'AttachmentViewFeatureComponent:attachment$:tap',
                    a
                })
            ),
            map(attachment => {
                attachment.SafeResource = this.sanitizer.bypassSecurityTrustResourceUrl(
                    attachment.File
                );
                return attachment;
            })
        );
    }
    setupSubscriptions() {
        this.attachment$
            .pipe(
                takeWhile(() => this.active),
                tap(a =>
                    this.log.verbose({
                        type: 'AttachmentViewFeatureComponent:attachment$:tap',
                        a
                    })
                )
            )
            .subscribe(attachment => {
                this.log.verbose({
                    type:
                        'AttachmentViewFeatureComponent:attachment$:subscribe',
                    attachment
                });
                this.attachment = attachment;
                this.attachment.SafeResource = this.sanitizer.bypassSecurityTrustResourceUrl(
                    this.attachment.File
                );
            });
    }
    ngAfterViewInit() {
        this.log.verbose({
            type: 'AttachmentViewFeatureComponent',
            fileId: this.fileId
        });
    }
}
